<template>
  <ul v-if="itemList.length > 0">
    <li v-for="(item, index) in itemList" :key="index">
      {{ item }}
    </li>
  </ul>
</template>
<script lang="ts" setup>

defineProps<{
  itemList: Array<string>,
}>();

</script>
<style lang="scss" scoped>
ul {
  columns: 1;
  column-gap: 32px;
  list-style-type: none;
  margin: 0px;
  padding: 0px;

  li {
    color: var(--pidz-body-text);
    break-inside: avoid;
    margin-bottom: 8px;
  }

  @media screen and (min-width: 480px) {
    columns: 2;
  }
}
</style>
